// Load integrations only inside their host browser, before route components mount.
let pending;
function loadScript(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = () => { script.remove(); reject(new Error('微信 SDK 加载失败')); };
    document.head.appendChild(script);
  });
}
export function ensureWechatSdk() {
  const ua = navigator.userAgent;
  if (!/MicroMessenger/i.test(ua)) return Promise.resolve();
  if (!pending) pending = loadScript('https://res.wx.qq.com/open/js/jweixin-1.2.0.js')
    .then(() => /wxwork/i.test(ua) ? loadScript('https://open.work.weixin.qq.com/wwopen/js/jwxwork-1.0.0.js') : undefined)
    .catch(error => { pending = undefined; throw error; });
  return pending;
}
